
import React, { useState, useRef, useEffect } from "react"
import {
    Button,
    Col,
    Form,
    Modal,
    Row,
    InputGroup,
    FormControl,
    OverlayTrigger,
    Tooltip
} from "react-bootstrap"
import { useNavigate } from "react-router-dom"
import { isLoggedIn } from "../../api/AuthService"
import { SearchOptionValues } from "../../constant/Constants"
import SearchResultDisp from "../search/SearchResultDisp"


function SearchGCASData(props) {
    // Modal props
    const { show, onHide, handleSetFrom } = props;
    const [topMargin, setTopMargin] = useState({});
    const [message, setMessage] = useState("");
    const [searchValue, setSearchValue] = useState("");
    const [loading, setLoading] = useState(false);
    const [optionValue, setOptionValue] = useState("gcas");
    const [selectedItems, setSelectedItems] = useState([]);
    const selectedItemsRef = useRef([]);
    const searchText = useRef();
    const messageRef = useRef();
    const navigate = useNavigate();

    useEffect(() => {
        setTopMargin({ marginTop: "3%" });
    }, []);

    const validateForm = () => {
        let formIsValid = true;
        if (!searchText.current.value || !searchText.current.value.trim()) {
            formIsValid = false;
            setMessage("* Please enter some value above.");
            setTimeout(() => messageRef.current?.scrollIntoView({ behavior: "smooth", block: "center" }), 0);
        }
        return formIsValid;
    };

    const handleSubmit = (e) => {
        if (!isLoggedIn()) {
            navigate("/");
        }
        e.preventDefault();
        if (validateForm()) {
            const encodedSearchText = btoa(encodeURIComponent(searchText.current.value.trim()));
            setSearchValue(encodedSearchText);
            setLoading(true);
            setMessage("");
            setSelectedItems([]);
        }
    };

    const handleChange = () => {
        setMessage("");
        if (!searchText.current.value || !searchText.current.value.trim()) {
            setSearchValue("");
            setLoading(false);
            setSelectedItems([]);
        }
    };

    const handleOnFocus = () => {
    };

    const handleRadioChange = (event) => {
        let selectedOption = "";
        if (event.target.childNodes[0]) {
            selectedOption = event.target.childNodes[0].value;
        } else {
            selectedOption = event.target.value;
        }
        setOptionValue(selectedOption);
        setSearchValue("");
        setLoading(false);
        setSelectedItems([]);
        const trimmedValue = searchText.current?.value?.trim() || "";
        if (!trimmedValue) {
            setMessage("* Please enter some value above.");
            setTimeout(() => messageRef.current?.scrollIntoView({ behavior: "smooth", block: "center" }), 0);
            return;
        }
        setMessage("");
        const encodedSearchText = btoa(encodeURIComponent(trimmedValue));
        setSearchValue(encodedSearchText);
        setLoading(true);
    };

    const handleSelectedItems = (items) => {
        selectedItemsRef.current = items;
        setSelectedItems(items);
    };

    const closeModal = (isSubmit) => {
        const itemsToSubmit = selectedItemsRef.current;
        if (isSubmit && itemsToSubmit.length > 25) {
            setMessage("* Maximum 25 GCAS allowed.");
            setTimeout(() => messageRef.current?.scrollIntoView({ behavior: "smooth", block: "center" }), 0);
            return;
        }
        setSearchValue("");
        setLoading(false);
        setMessage("");
        setSelectedItems([]);
        if (handleSetFrom) handleSetFrom();
        if (isSubmit && itemsToSubmit.length > 0) {
            onHide(itemsToSubmit.join(","));
        } else {
            onHide();
        }
    };

    return (
        <Modal
            show={show}
            onHide={onHide}
            aria-labelledby="contained-modal-title-vcenter"
            centered
            dialogClassName="my-modal searchGCASModalDialog"
            contentClassName="searchGCASModalContent"
            style={{ overflowY: "hidden" }}
            backdrop="static"
            keyboard={false}
        >
            <Modal.Header closeButton onHide={() => closeModal(false)}></Modal.Header>
            <Modal.Body style={{ overflowY: "auto" }}>
                <Form onSubmit={handleSubmit} className="loginForm" style={{ width: "100%" }}>
                            <div className="searchContent" style={{ ...topMargin, maxWidth: "100%", marginTop: "0%" }}>
                                <div style={{ width: "40%", margin: "0 auto" }}>
                                    <Form.Group controlId="searchBox" style={{ marginBottom: "0rem" }}>
                                        <InputGroup>
                                            <FormControl
                                                className={`placeHolderText searchBox`}
                                                ref={searchText}
                                                placeholder="&#61442; What are you Looking For?"
                                                type="text"
                                                onChange={handleChange}
                                                onFocus={handleOnFocus}
                                            />
                                            <Button bsPrefix="searchBtnText" type="submit">
                                                Search
                                            </Button>
                                        </InputGroup>
                                        <InputGroup>
                                            {SearchOptionValues && (
                                                <div className="GCASradbtnClass">
                                                    {SearchOptionValues.map((item, index) => (
                                                        <OverlayTrigger
                                                            key={index}
                                                            delay={{ show: 300, hide: 300 }}
                                                            overlay={<Tooltip id={item.value}>{item.toolTip}</Tooltip>}
                                                            placement="bottom"
                                                        >
                                                            <span
                                                                key={index}
                                                                onClick={handleRadioChange}
                                                                style={{ cursor: "pointer" }}
                                                            >
                                                                <input
                                                                    id={item.value}
                                                                    value={item.value}
                                                                    checked={optionValue === item.value}
                                                                    type="radio"
                                                                    readOnly
                                                                />{" "}
                                                                {item.display} &nbsp;
                                                            </span>
                                                        </OverlayTrigger>
                                                    ))}
                                                </div>
                                            )}
                                        </InputGroup>
                                    </Form.Group>
                                    <Row>
                                        <Col>
                                            <p ref={messageRef} style={{ marginLeft: "0rem", color: "#a00505" }} className="labels">
                                                {message}
                                            </p>
                                        </Col>
                                    </Row>
                                </div>
                                {loading && searchValue && searchValue.trim() && (
                                    <div style={{ width: "100%", padding: "2%", boxSizing: "border-box" }}>
                                        <SearchResultDisp
                                            searchType={optionValue}
                                            searchData={searchValue.trim()}
                                            loadingColor="#007bff"
                                            onSelectItems={handleSelectedItems}
                                        />
                                    </div>
                                )}
                            </div>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="primary" onClick={() => closeModal(true)}>
                    Submit
                </Button>
            </Modal.Footer>
        </Modal>
    );
}

export default SearchGCASData;